module.exports = __webpack_public_path__ + "img/4.3aedb65b.jpg";